module.exports = __webpack_public_path__ + "80301ff4ec69240bccce4c1ef488aa35.pdf";